import React from 'react';
import PropTypes from 'prop-types';
import { Input, Form } from 'antd';

const SimpleTextInput = (props) => {
  const { label, icon, ...rest } = props;
  return (
    <Form.Item className={`styled-input-comp-container ${icon && 'has-icon'}`}>
      {label && <label className="styled-label">{label}</label>}
      <Input
        {...rest}
        className={`styled-form-input-comp ${icon && 'has-icon'}`}
        prefix={icon}
      />
    </Form.Item>
  );
};

SimpleTextInput.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  icon: PropTypes.string,
};

export default SimpleTextInput;
